var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.082 6.353h-4.235V0H4.494v6.353H.26l7.412 7.412 7.411-7.412zM.26 15.883V18h14.823v-2.118H.26z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "80ffc8bf908cffaaac2eefaa02d6243b.svg";
export { SvgDownloadIcon as ReactComponent };